export default __webpack_public_path__ + "static/bisolnatur-urun-yeni-73a3b4ffe3705aa926bce73fa123d9b0.png";